import * as React from "react";
import { Component } from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  Glyphicon,
  Modal,
  Nav,
  Navbar,
  NavItem,
} from "react-bootstrap";
import { Redirect } from "react-router";
import { NavLink } from "react-router-dom";
import LoadingStatus from "src/components/common/LoadingStatus";
import { TABLENAMES, TIMEOUT } from "src/global";
import { IProject } from "../../components/projects/interfaces";
import Projects from "../../components/projects/Projects";
import "../../css/pages/projects/projectspage.css";
import fs from "../../services/config/fbConfig";
import { IProjectsPageProps, IProjectsPageState } from "./interfaces";

export default class ProjectsPage extends Component<IProjectsPageProps, IProjectsPageState> {
  private projectsCollection: firebase.firestore.CollectionReference;
  private unsubscribe: any;
  public constructor(props: IProjectsPageProps) {
    super(props);

    this.state = {
      copying: false,
      deleting: false,
      loading: true,
      projects: [],
      showAddProjectModal: false,
      location: "",
    };

    this.showAddProjectModal = this.showAddProjectModal.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.activateProject = this.activateProject.bind(this);
    this.deactivateProject = this.deactivateProject.bind(this);
    this.addProject = this.addProject.bind(this);
    this.editProject = this.editProject.bind(this);
    this.addProjectModal = this.addProjectModal.bind(this);
    this.closeAddProjectModal = this.closeAddProjectModal.bind(this);
    this.handleProjectLocationChanged = this.handleProjectLocationChanged.bind(this);
    this.copyProject = this.copyProject.bind(this);

    this.deleteCollectionData = this.deleteCollectionData.bind(this);
  }

  public componentWillMount() {
    this.projectsCollection = fs.fs.collection(TABLENAMES.PROJECTS);
  }

  public componentDidMount() {
    const { appService } = this.props;
    this.unsubscribe = this.projectsCollection
      .where("uid", "==", appService.getUserProfileId())
      .orderBy("timestamp")
      .onSnapshot(this.onCollectionUpdate);
  }

  public componentWillUnmount() {
    this.unsubscribe(this.onCollectionUpdate);
  }

  public render() {
    const { appService } = this.props;

    if (!appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus type="Watch" text="Loading..." />;
    }

    if (this.state.deleting) {
      return <LoadingStatus type="Watch" text="Deleting project..." />;
    }

    if (this.state.copying) {
      return <LoadingStatus type="Watch" text="Copying project..." />;
    }

    return (
      <div className="container-fixed-navbar">
        <div className="subnavbar-container">
          <Navbar collapseOnSelect={true} inverse={false}>
            <Navbar.Header>
              <Navbar.Brand>
                <NavLink to="/">Solar Projects</NavLink>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav pullRight={true}>
                <NavItem>
                  <Button bsSize="small" bsStyle="primary" onClick={this.showAddProjectModal}>
                    <Glyphicon glyph="glyphicon glyphicon-plus-sign" /> Add
                  </Button>
                </NavItem>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
        <div className="container">
          <Projects
            projects={this.state.projects}
            appService={this.props.appService}
            deleteProject={this.deleteProject}
            activateProject={this.activateProject}
            deactivateProject={this.deactivateProject}
            editProject={this.editProject}
            copyProject={this.copyProject}
          />
        </div>
        {this.addProjectModal()}
      </div>
    );
  }

  private onCollectionUpdate = (querySnapshot: firebase.firestore.QuerySnapshot) => {
    this.setState({ loading: true });
    const projects: IProject[] = [];
    querySnapshot.forEach(doc => {
      const { uid, location, timestamp } = doc.data();
      projects.push({ timestamp, location, id: doc.id, uid });
    });
    this.setState({ projects, loading: false });
  };

  private addProjectModal() {
    return (
      <Modal
        show={this.state.showAddProjectModal}
        onHide={this.closeAddProjectModal}
        backdrop="static"
      >
        <Modal.Header closeButton={true}>
          <Modal.Title>Add Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="projectLocation">
            <ControlLabel>New Project Location</ControlLabel>
            <FormControl
              autoFocus={true}
              type="text"
              value={this.state.location}
              onChange={this.handleProjectLocationChanged}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button bsSize="small" bsStyle="primary" onClick={this.addProject}>
            Add
          </Button>
          <Button bsSize="small" bsStyle="danger" onClick={this.closeAddProjectModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private showAddProjectModal() {
    this.setState({ showAddProjectModal: true });
  }

  private closeAddProjectModal() {
    this.setState({ showAddProjectModal: false });
  }

  private handleProjectLocationChanged(e: any) {
    this.setState({ location: e.currentTarget.value });
  }

  private addProject() {
    this.projectsCollection.add({
      timestamp: Date.now(),
      uid: this.props.appService.getUserProfileId(),
      location: this.state.location,
    });
    this.setState({ showAddProjectModal: false, location: "" });
  }

  private deleteProject(id: string) {
    if (confirm("Are you sure you want to delete this project?")) {
      this.setState({ deleting: true });

      const projectDocument = this.projectsCollection.doc(id);
      projectDocument
        .get()
        .then(docSnapshot => {
          if (docSnapshot.exists) {
            projectDocument
              .collection(TABLENAMES.ADVANCEDSINGLERATESTATEMENTS)
              .get()
              .then(querySnapshot => {
                querySnapshot.forEach(doc => {
                  if (doc.exists) {
                    const document = projectDocument
                      .collection(TABLENAMES.ADVANCEDSINGLERATESTATEMENTS)
                      .doc(doc.id);
                    this.deleteCollectionData(document, TABLENAMES.SERVICECHARGES);
                  }
                });
              })
              .then(() => {
                this.deleteCollectionData(projectDocument, TABLENAMES.ADVANCEDSINGLERATESTATEMENTS);
                projectDocument
                  .collection(TABLENAMES.ADVANCEDDUALRATESTATEMENTS)
                  .get()
                  .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                      if (doc.exists) {
                        const document = projectDocument
                          .collection(TABLENAMES.ADVANCEDDUALRATESTATEMENTS)
                          .doc(doc.id);
                        this.deleteCollectionData(document, TABLENAMES.SERVICECHARGES);
                      }
                    });
                  })
                  .then(() => {
                    projectDocument
                      .collection(TABLENAMES.ADVANCEDDUALRATESTATEMENTS)
                      .get()
                      .then(querySnapshot => {
                        querySnapshot.forEach(doc => {
                          if (doc.exists) {
                            const document = projectDocument
                              .collection(TABLENAMES.ADVANCEDDUALRATESTATEMENTS)
                              .doc(doc.id);
                            this.deleteCollectionData(document, TABLENAMES.TAXESANDFEES);
                          }
                        });
                      })
                      .then(() => {
                        this.deleteCollectionData(
                          projectDocument,
                          TABLENAMES.ADVANCEDDUALRATESTATEMENTS
                        );
                        this.deleteCollectionData(
                          projectDocument,
                          TABLENAMES.SIMPLESINGLERATESTATEMENTS
                        );
                        this.deleteCollectionData(
                          projectDocument,
                          TABLENAMES.SIMPLEDUALRATESTATEMENTS
                        );
                        projectDocument
                          .collection("statements")
                          .orderBy("statementDate")
                          .get()
                          .then(querySnapshot => {
                            querySnapshot.forEach(statement => {
                              if (statement.exists) {
                                const { storagePath } = statement.data() as any;
                                if (storagePath && storagePath !== "") {
                                  fs.fsStorage
                                    .ref()
                                    .child(storagePath)
                                    .delete()
                                    .catch(() => {
                                      console.log("file not found");
                                    });
                                }
                              }
                            });
                          });
                        this.deleteCollectionData(projectDocument, TABLENAMES.STATEMENTS);
                        this.deleteCollectionData(projectDocument, TABLENAMES.GUARANTEEDPOWERTABLE);
                      });
                  });
              });
          }
        })
        .then(() => {
          projectDocument.delete();
        })
        .then(() => {
          setTimeout(() => {
            this.setState({ loading: false, deleting: false });
          }, TIMEOUT);
        });
    }
  }
  private deleteCollectionData(
    document: firebase.firestore.DocumentReference,
    collectionName: string
  ): void {
    const collection = document.collection(collectionName);
    const ids: string[] = [];
    collection
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            ids.push(doc.id);
          }
        });
      })
      .then(() => {
        ids.forEach(id => {
          collection.doc(id).delete();
        });
      });
  }

  private activateProject(id: string, location: string): void {
    const { appService } = this.props;
    appService.setActiveProject(id, location);
    this.setState({ projects: this.state.projects });
  }

  private deactivateProject(): void {
    const { appService } = this.props;
    appService.resetActiveProject();
    this.setState({ projects: this.state.projects });
  }

  private editProject(id: string): void {
    this.props.history.push(`/project/${id}`);
  }

  private copyProject(id: string, location: string): void {
    this.setState({ copying: true, loading: true });
    this.projectsCollection
      .add({
        timestamp: Date.now(),
        uid: this.props.appService.getUserProfileId(),
        location: "Copy of " + location,
      })
      .then(doc => {
        this.props.appService.copyProject(id, doc.id);
      })
      .then(() => {
        setTimeout(() => {
          this.setState({ copying: false, loading: false });
        }, TIMEOUT);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/ProjectsPage.tsx